import { CheckIcon, CurrencyEuroIcon } from "@heroicons/react/24/outline"
import Head from "next/head"
import Image from "next/image"
import Link from "next/link"
import Script from "next/script"

import data from "../../components/data"
import Disclosure from "../../components/disclosure"
import { BestPrice, Companies } from "../../components/info"
import { orderByOrder } from "../../components/utils"

// Kurso aprašymas
// Python programavimo kalba yra lyderė duomenų analizės srityje. Versle Python keičia ir .
// Python programavimo kalba
// Ko išmoksite
// Po mokymų
// - Galimi įgūdžiai
// - Rinktis tolimesnę specializaciją
// Mokymai įmonėms
// Individualūs mokymai
// Lektoriai
// D.U.K

const CourseInstance = ({ instance, course }) => {
  const onClick = () => {
    window.dataLayer.push({
      event: "courseInstanceClick",
      name: `${course.name}_${instance.startDate}`,
    })
  }
  return (
    <div key={instance.startDate}>
      <div className="pb-2 text-xl font-bold capitalize md:col-span-2 ">
        {/* <div>{course.name}</div> */}
        <div>
          {instance.extraTypeEmoji} {instance.extraType} {instance.startDate}
        </div>
      </div>
      <div>
        <div>Kur: {instance.courseMode}</div>

        {/* <div>Pradžia: {instance.startDate}</div>
        <div>Pabaiga: {instance.endDate}</div> */}
        {/* <div>Trukmė: 5 dienos</div> */}
        <div>
          Trukmė: {instance.startDate} – {instance.endDate}
        </div>
        <div>
          Laikas: <span className="font-bold">{instance.extraDayTime}</span>
        </div>
        {/* <div>Tipas: {instance.extraTypeEmoji} {instance.extraType}</div> */}
        <div>Intensyvumas: {course.hours} val.</div>
        <div>Kaina: nuo {instance.offers.price} €</div>
        <div>
          Valandos kaina: nuo{" "}
          <span className="font-bold text-yellow-700 dark:text-yellow-200">
            {instance.offers.price / course.hours} €/val.
          </span>
        </div>
        <div className="flex justify-center">
          <RegistrationButton
            href={data.links.generalRegistrationForm}
            onClick={onClick}
          />
        </div>
      </div>
    </div>
  )
}

const RegistrationButton = ({ href, onClick }) => {
  return (
    <div className="p-5">
      <button>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={` transition-border rounded-md bg-mustard p-2 font-bold uppercase transition-colors duration-1000 dark:bg-green-500 dark:text-black`}
          onClick={onClick}
        >
          Registracija
        </a>
      </button>
    </div>
  )
}

const Course = () => {
  const course = data.courses.filter((course) => course.id == "p-b")[0]
  const schema = (({ name, description, courseInstances }) => ({
    name,
    description,
    courseInstances,
  }))(course)
  schema["@context"] = "https://schema.org"
  schema["@type"] = "Course"
  schema["provider"] = {
    "@type": "Organization",
    name: "Pirmas kodas",
    sameAs: "https://pirmaskodas.lt",
  }

  const courseInstances = schema.courseInstances

  const schemaElement = (
    <Script
      id="schemaPython"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    ></Script>
  )

  const sampleProjects = [
    [
      "Kryžiukai-nuliukai",
      "Vienas labiausiai žinomų žaidimų. Pabaigę mokymus sugebėsite parašyti kryžiukų-nuliukų žaidimą-programą!",
      "/xo.png",
      "dark:invert",
    ],
    [
      "Failų skirstytojas",
      "Funkcionalumas: nurodome programai failą arba direktoriją, programa suskirsto rastus failus pagal jų plėtinius (txt, pdf, xlsx) į atskiras direktorijas.",
      "/file-tree.webp",
      "dark:invert",
    ],
    [
      "Fotografijų tvarkytojas",
      "Funkcionalumas: nurodome direktorija, programa automatiškai pritaiko efektus, pakeičia šviesumą, kontrastą, apkarpo, prideda logotipą ir t.t.",
      "/image-edit.jpg",
      "",
    ],
    [
      "Užduočių (to do) programėlė",
      "Funkcionalumas: pridėk užduotį, ištrink užduotį, pažymėk kaip padarytą, pridėk terminą, parodyk šios >conos užduotis ir t.t.",
      "/todo.webp",
      "dark:invert",
    ],
    [
      "Prekių kainų rinkėjas",
      "Iš numatyto puslapio, automatiškai, surink reikalingas prekių pavadinimus, aprašymus. Programa, o informacija automatiškai sukrenta į txt arba Excel failą!",
      "/scraper.png",
      "dark:invert",
    ],
  ]
  const features = [
    // ["Akademinė veikla", "Python academy"],
    [
      "Stebėk paskaitą NEMOKAMAI",
      "Jei negalite išsirinkti mokymų, ateikite stebėti pasirinktą paskaitą NEMOKAMAI",
      "🆓",
    ],
    [
      "Paskaitų įrašai",
      "Turėsite galimybę gauti paskaitų įrašus, jei praleidote paskaitą ar norite pasikartoti",
      "📹",
    ],
    // [
    //   "Tikslas",
    //   "Individuali, personalizuota IT mokymų programa, kurios pagrindinis tikslas – žmogaus įdarbinimas tech sektoriuje",    "🤝"],
    [
      "Karjeros planavimas",
      "Po mokymų absolventams padedame pasirinkti tolimesnį kelią, pasiruošti CV, pasirengti pokalbiui su darbdaviu.",
      "🤝",
    ],
    [
      "Išduodamas sertifikatas",
      "Po mokymų įteikiamas oficialus, Pirmas kodas kursų išklausymo sertifikatas.",
      "🎓",
    ],
    [
      "Nemokamas kurso kartojimas",
      "Galimybė metų bėgyje grįžti kartoti kurso NEMOKAMAI",
      "⏪",
    ],
    // // ["Pinigų grąžinimas", ""],
    // ["1 ant 1 konsultacijos (3 vnt.)", "Konsultacijos"],
  ]
  return (
    <div>
      <Head>
        <title>Python pradedantiesiems | Pirmas kodas</title>
        <meta
          name="description"
          content='Mokymai "Python pradedantiesiems" skirti norintiems išmokti populiariausią pasaulyje programavimo kalbą. Python yra lengvai skaitoma ir labai plačiai naudojama.'
        />
      </Head>

      {schemaElement}
      {/* <div className="mx-auto"> */}
      <div className="grid gap-2 lg:grid-cols-12">
        <aside className="px-2 lg:col-span-3 ">
          <div className="my-background sticky top-14 mt-0">
            <h2>Navigacija</h2>
            <ul className="underline-none flex list-disc flex-col gap-2 pl-4">
              <li>
                <Link href="#main">Python pradedantiesiems</Link>
              </li>
              <li>
                <Link href="#projects">Baigiamųjų darbų pavyzdžiai</Link>
              </li>
              <li>
                <Link href="#python-academy">PythonAcademy.com</Link>
              </li>
              <li>
                <Link href="#program">Programa</Link>
              </li>
              <li>
                <Link href="#features">Savybės</Link>
              </li>
              <li>
                <Link href="#trainer">Dėstytojas</Link>
              </li>
              <li>
                <Link href="#price">Kainos</Link>
              </li>
              <li>
                <Link href="#discounts">Nuolaidų sistema</Link>
              </li>
              <li>
                <Link href="#payment">Apmokėjimo galimybės</Link>
              </li>
            </ul>
          </div>
        </aside>
        {/* </div> */}
        <article className="prose max-w-none dark:prose-invert  prose-h2:mt-0 prose-h2:pt-2 lg:col-span-6 ">
          <div id="main" className="my-background">
            <h1 className="break-words">Python pradedantiesiems</h1>
            <div>
              <h2>Aprašymas</h2>
              <p>{course.description}</p>
            </div>
            <div>
              <h3>Tikslinė auditorija</h3>
              <p>
                Kursas sukurtas neturintiems programavimo patirties. Tereikia
                gebėti naudotis operacine sistema, kurti, kopijuoti, redaguoti
                failus, įsidiegti programinę įrangą. Lengviau bus tiems, kurie
                yra įgūdę MS Office paketo naudotojai arba yra susipažinę su
                HTML ar panašiomis technologijomis.
              </p>
            </div>
            <div>
              <h3>Ką veikti pabaigus?</h3>
              <p>
                Šiame kurse įgijote Python pagrindus. Jau galite skaityti Python
                kodą, parašyti nedidelę programą. Gali būti, kad pritaikysite
                Python darbovietėje arba namuose. Tačiau dar neturite tiek
                įgūdžių, kad galėtumėte būti pilnaverčiu programuotoju ar
                duomenų analitiku. Norintiems pasiekti kitą lygį kviečiame
                rinktis vieną iš tolimesnių kursų.{" "}
                <Link href="courses">Pirmas kodas kursai</Link>
              </p>
            </div>
          </div>

          <div id="projects" className="my-background">
            <h2>Baigiamųjų darbų pavyzdžiai</h2>
            <p>
              Keletas pavyzdžiu baigiamųjų projektų, kuriuos galėtų tikėtis
              padaryti šio kurso studentai
            </p>
            <div>
              {sampleProjects.map(
                ([name, description, imagePath, additionalClass]) => {
                  return (
                    <div
                      key={name}
                      className="grid items-center gap-3 p-3 md:grid-cols-6"
                    >
                      <h3 className="md:col-span-6">{name}</h3>
                      <p className="md:col-span-4 ">{description}</p>
                      <div className="flex justify-center md:col-span-2">
                        <Image
                          className={"m-0 h-auto " + additionalClass}
                          src={imagePath}
                          width={100}
                          height={100}
                          alt="work"
                        ></Image>
                      </div>
                    </div>
                  )
                },
              )}
            </div>
          </div>
          <br></br>
          <div id="python-academy" className="my-background  break-words">
            <h2>Python-Academy.com</h2>
            <h3 className="m-0">Kaip užtikrinama kurso kokybė?</h3>
            <p>
              Pirmas kodas yra sertifikuoti{" "}
              <a href="https://python-academy.com">PythonAcademy.com</a>.
              partneriai. PythonAcademy.com yra nuo 2006 metų Python mokymus
              veikianti kompanija. Pirmo kodo Python pradedantiesiems kursas yra
              parengtas būtent pagal PythonAcademy.com programą.
            </p>
            {/* <a href="https://www.python-academy.com/courses/python_course_nonprogrammers.html">
                Originalų kurso aprašą
              </a> */}
            <div className="flex items-center">
              <div className="hidden dark:block ">
                <Link href="https://www.python-academy.com/">
                  <Image
                    className="h-auto w-full"
                    src="/pya_logo_white.svg"
                    alt="Python Academy"
                    width={175 * 2}
                    height={68 * 2}
                  // placeholder="blur"
                  />
                </Link>
              </div>

              <div className="block dark:hidden">
                <Link href="https://www.python-academy.com/">
                  <Image
                    className="h-auto w-full"
                    src="/pya_logo_rgb.svg"
                    alt="Python Academy"
                    width={175 * 2}
                    height={68 * 2}
                  // placeholder="blur"
                  />
                </Link>
              </div>
            </div>

            <div className="max-h-max-1/2 flex flex-col gap-8 p-4">
              <div className="text-lg">
                <span className="p-3 text-center text-3xl">9000+</span>
                studentų dalyvavo PythonAcademy.com kursuose
              </div>
              <div className="text-lg ">
                <span className="p-3 text-center text-3xl">816+</span>
                mokymų grupių pravedė PythonAcademy.com{" "}
              </div>

              <div className="text-lg ">
                <span className="p-3 text-center text-3xl">2250+</span> dienų
                mokymų pravedė PythonAcademy.com{" "}
              </div>

              <div className="text-left text-lg">
                <span className="p-3 text-center text-3xl">3300+</span>
                studentų baigė mokymus pagal šią programą
              </div>
            </div>
            {/* <div>
              <a className="bg-green-500 rounded-xl p-2">
                Originalus kurso aprašymas
              </a>
            </div> */}
          </div>

          <div id="program">
            {/* <div id="program" className="my-background">

          <Disclosure name={<h2>Programa</h2>} content={<div> */}
            <div className="my-background mt-10">
              <h2>Programa</h2>
              <div>
                <h3>Pagrindai ir duomenu strukturos</h3>
                <ul>
                  <li>Ivadas i JupyterLab</li>
                  <li>Python sintaksė</li>
                  <li>Statements and expressions</li>
                  <li>Control flow</li>
                  <li>Ciklai</li>
                  <li>Duomenų tipų apžvalga</li>
                  <li>Sąrašai ir tuplai</li>
                  <li>Žodynai</li>
                  <li>Setai</li>
                </ul>

                <h3>Procedūrinis ir objektinis programavimas</h3>
                <ul className="simple">
                  <li>Funkcijos</li>
                  <li>Generatoriai ir iteratoriai</li>
                  <li>Klasės</li>
                  <li>Paveldėjimas</li>
                  <li>Operator overloading</li>
                  <li>Išimčių valdymas</li>
                  <li>Input / output</li>
                </ul>

                <h3>Projektai</h3>
                <ul>
                  <li>nedidelis Python projektas</li>
                  <li>Moduliai ir paketai</li>
                  <li>Pavadinimai ir objektai</li>
                  <li>Namespaces and scoping</li>
                </ul>

                <h3>Practical Applications and Libraries</h3>
                <ul>
                  <li>Teksto apdorojimas</li>
                  <li>System functions</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="my-background">
            <h2>Papildoma informacija apie programą</h2>
            <div>
              <h3>Pratimai</h3>
              <p>
                Visi dalyviai gali sekti žingsinius kompiuteryje. Kiekvieno
                skyriaus pabaigoje daromi pratimai. Tokiu būdu įsisavinime
                įgūdžius.
              </p>
            </div>
            <div>
              <h3>Kurse naudojama programinė įranga</h3>
              <p>
                Kurso dalyviams nereikės diegti papildomos programinės įrangos.
                T.y. į kompiuterį nereikės instaliuoti jokių programų. Tereikia
                naršyklės ir patikimo interneto ryšio.
              </p>
            </div>

            <div>
              <h3>Kurso medžiaga</h3>
              <p>
                Kiekvienam kurso dalyviui visa kurso medžiaga bus pateikta PDF
                formatu. Dokumente bus visa teorinė medžiaga bei kurso metu
                naudotas kodas.
              </p>
            </div>
          </div>

          <Companies />

          <div id="features" className="my-background">
            <h2>Savybės</h2>
            {features.map(([feature, desc, emoji]) => (
              <div
                key={feature}
                className="grid grid-cols-12 grid-rows-3 items-center border-gray-900 p-1"
              >
                {/* <div className="col-span-1 text-yellow-500 ">
                <CheckIcon className="h-10 " />
              </div> */}
                <div className="col-span-3 text-center text-yellow-500 md:col-span-1">
                  <span className="text-4xl ">{emoji}</span>
                </div>
                <div className="col-span-9 text-2xl md:col-span-11">
                  {feature}
                </div>
                <p className="col-span-12 row-span-2 ">{desc}</p>
              </div>
            ))}
          </div>

          <div id="trainer" className="my-background">
            <h2>Dėstytojas</h2>
            <h3>Aidis Stukas</h3>
            <div className="md:flex-cols flex items-center gap-2">
              <div className="items-center gap-2 md:flex">
                <Image
                  src="/aidis.png"
                  height={250}
                  width={250}
                  alt="Aidis Stukas"
                ></Image>
                <div>
                  <p>
                    Programuoti pradėjau 2015 metais. Darbų patirtis: duomenų
                    surinkimas (web-scraping), tinklalapių kūrimas su Django,
                    front-end su React ir NextJS, Shopify aplikacijų kūrimas
                    AdTech srityje, integracijų kūrimas su reklamos platformomis
                    (pvz. Google Ads, Facebook Ads).{" "}
                  </p>
                  <p>
                    Nuo 2018 metų dėsčiau programavimą su Python dviejose
                    didžiausiose Lietuvos programavimo mokymus teikiančiose
                    kompanijose. Vedžiau mokymus Python pažengusiųjų, Duomenų
                    analitikos, Agile projektų valdymo kursus individualių
                    asmenų grupėms ir kompanijoms.
                  </p>
                  <p>
                    Tikiu, kad mano žingios ir įgūdžiai gali Jums padėti
                    perprasti programavimą. Iki susitikimų!
                  </p>
                </div>
              </div>
            </div>
            <p>
              Detaliau sužinoti galite mano LinkedIn profilyje
              <Link
                className="inline"
                href="https://lt.linkedin.com/in/aidis-stukas"
              >
                <Image
                  className="m-10 inline"
                  width={64}
                  height={64}
                  src="/linkedin.svg"
                  alt="Aidis Stukas LinkedIn profile inline"
                ></Image>
              </Link>
            </p>
          </div>

          {/* <div id="price" className="my-background">
            <h2>Kaina</h2>
            <div>
              <div className="text-center text-5xl ">{course.price} €</div>
              <div className="p-10 text-center text-3xl font-bold">
                Tik {course.price / course.hours} €/val.
              </div>
            </div>
            <BestPrice />
          </div> */}

          <div id="discounts" className="my-background">
            <h2>Nuolaidų sistema</h2>
            <div>
              <ul>
                <li className="">
                  Apmokėjus 3 dienoms iki grupės pradžios taikome 10 % nuolaidą!
                </li>
                <li className="">
                  20 % nuolaida Jums jei į grupę atsivedate draugą.
                </li>
              </ul>
            </div>
            <p className="text-sm text-gray-500">* Nuolaidos nesumuojamos</p>
          </div>

          <div id="payment" className="my-background">
            <h2>Apmokėjimo galimybės</h2>
            <ul>
              <li className="">
                Lankstus apmokėjimas, apmokėkite per 14 d. nuo kurso pabaigos.
              </li>
            </ul>
          </div>

          <div id="uzt" className="my-background">
            <h2>Studijų finansavimas per Užimtumo tarnybą</h2>
            <p>
              Užimtumo tarnyba prie LR SADM skiria finansavimą nesimokančių,
              nedirbančių ir darbą pakeisti ketinančių asmenų mokymui.
              Finansavimas skiriamas formaliam, profesiniam mokymui, t.y.
              finansuojami ne trumpi kursai, bet ilgesnės studijos, leidžiančios
              įgyti kvalifikaciją.
            </p>
            <div className="flex justify-end">
              <Link
                href="/uzimtumo-tarnyba"
                className="transition-border mx-10 rounded-md bg-mustard px-5 py-4 text-xl font-bold transition-colors duration-1000 dark:bg-green-500 dark:text-black sm:text-xl md:text-xl"
              >
                Daugiau
              </Link>
            </div>
          </div>
        </article>
        <aside className="lg:col-span-3">
          <div className="sticky top-14">
            <div className="my-background prose mt-0 max-w-none justify-items-center  dark:prose-invert">
              <h2 className="">Artimiausios Python pradedantiesiems grupės</h2>
              <div className=" grid items-center justify-items-center sm:grid-cols-2 lg:grid-cols-1">
                {courseInstances.sort(orderByOrder).map((i) => (
                  <CourseInstance
                    key={i.startDate}
                    instance={i}
                    course={course}
                  />
                ))}
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  )
}

export default Course
